import { alpha } from "@mui/material/styles";

// Estilos do modal de confirmação da ação "Criar OS" (OS faltante),
// no padrão de cabeçalho dos blocos da Central (título mySubtitle + caption).
const styles = (theme) => ({
	titulo: {
		display: "flex",
		flexDirection: "column",
		gap: 0.25,
	},
	subtitulo: {
		color: theme.palette.text.secondary,
		fontWeight: 400,
	},
	// Bloco de contexto do alerta que originou a ação.
	resumoAlerta: {
		p: "10px 12px",
		borderRadius: "10px",
		border: `1px solid ${theme.palette.divider}`,
		backgroundColor: alpha(theme.palette.text.primary, 0.03),
		display: "flex",
		flexDirection: "column",
		gap: 0.25,
	},
	rotuloResumo: {
		color: theme.palette.text.secondary,
		fontWeight: 600,
		textTransform: "uppercase",
		letterSpacing: "0.4px",
	},
});

export default styles;
